import { t } from "@lingui/macro";

export function Title() {
  return <h1 className="typo-display-lg-bold text-gray-900">{t`Váš přehled`}</h1>;
}
